export default {"src":"https://fishbrain.com/_next/static/media/ic_weather_day_176.060de6f7.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};